import * as Action from './action';
import _ from 'underscore';

const defineInitialState = () => ({
  shipments: [],
  total_charges: 0,
});

//shipment
const pushShipment = (item, shipments) => {
  let results = shipments;

  if (shipments?.length > 0) {
    results.push(item);
  } else {
    results[0] = item;
  }

  return results;
};

const shipmentUpdate = (shipments, item, index) => {
  shipments[index] = item;

  return shipments;
};

const shipmentDelete = (shipments, index) => {
  shipments.splice(index, 1);

  return shipments;
};

const shipmentTotal = (shipments) => {
  let sum = _.reduce(
    shipments,
    function (sum, item) {
      return sum + item?.total_charges;
    },
    0
  );

  return sum;
};

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$addShipment.ACTION:
      const shipment = pushShipment(action?.item, state?.shipments);
      const total = shipmentTotal(state?.shipments);
      return {
        ...state,
        shipments: shipment,
        total_charges: total,
      };
    case Action.$updateShipment.ACTION:
      const c = shipmentUpdate(state?.shipments, action?.item, action?.index);
      const t = shipmentTotal(state?.shipments);
      return {
        ...state,
        shipments: c,
        total_charges: t,
      };
    case Action.$deleteShipment.ACTION:
      const i = shipmentDelete(state?.shipments, action?.index);
      const ti = shipmentTotal(state?.shipments);
      return {
        ...state,
        shipments: i,
        total_charges: ti,
      };
    default:
      return state;
  }
}
